module.exports = __webpack_public_path__ + "img/5_50.9483255a.png";